import { render, staticRenderFns } from "./ArticleViewer.vue?vue&type=template&id=25aba7e2&"
import script from "./ArticleViewer.vue?vue&type=script&lang=js&"
export * from "./ArticleViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports